import React from "react";

export default function MainFooter() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="main-footer border-top border-light-3 bg-white">
      <div className="container">
        <div className="d-flex flex-column flex-md-row justify-content-between align-items-center py-3 gap-2">
          <div className="text-muted small">© {currentYear} Kendrick Trade. All rights reserved.</div>
          <div className="d-flex align-items-center gap-3">
            <a href="https://www.kendricktrade.com/terms-of-use" target="_blank" rel="noopener noreferrer" className="footer-link text-muted small text-decoration-none">
              Terms of Service
            </a>
            <span className="text-muted">|</span>
            <a
              href="https://www.kendricktrade.com/privacy-notice"
              target="_blank"
              rel="noopener noreferrer"
              className="footer-link text-muted small text-decoration-none"
            >
              Privacy Policy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
